import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { environment } from '../../../environments/environment';
import * as fromApp from '../../store/app.reducers';
import * as authActions from '../../public/store/root-actions';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AssetClassData } from '../models/dashboard/asset-class-data';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class GlobalService {
    public mainHost: string;
    public lang: string;
    public mobile!: boolean
    // public sobject:any;
    // public fobject:any;
    public SaveFilter:boolean=false;
    public pdfLoader = new BehaviorSubject<boolean>(false);
    public homeFilter = new BehaviorSubject<any>('');

    public theme = new BehaviorSubject<any>('light');
    
    private get headers() {
        const accessToken: string = `Bearer ${localStorage.getItem('__bt')}`;
        const headers: HttpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: accessToken,
        });
        return headers;
    }

    constructor(
        private store: Store<fromApp.AppState>,
        private translate: TranslateService,
        private httpClient: HttpClient,
    ) {
        this.mainHost = `${environment.host}`;
        this.lang = localStorage.getItem('language')
            ? localStorage.getItem('language').split('-')[0]
            : 'en-US';
    }
   
    changeLanguage(language: string): void {
        if (
            language !== 'heb' &&
            document.getElementsByTagName('html')[0].hasAttribute('dir')
        ) {
            document.getElementsByTagName('html')[0].removeAttribute('dir');
        } else if (
            language === 'heb' &&
            !document.getElementsByTagName('html')[0].hasAttribute('dir')
        ) {
            document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
        }
        
        language
            ? localStorage.setItem('language', language)
            : localStorage.setItem('language', 'en-US');
        if(language ==null) {language='en-US';}
        this.lang = language.split('-')[0];
        this.translate.use(language);
        this.store.dispatch(new authActions.SetLanguage(language));
    }
    visitorCountry() {
        return this.httpClient.get(
            `${this.mainHost}/public/visitor/country`,
            { headers: this.headers },
        );
    }
}
